@if (isTypeButton) { @if (!isScreenShareLocal) {
<av-tooltip message="Share your screen" [enabled]="!isScreenShareActive">
  <button
    [attr.aria-label]="'Share screen or window' | translate"
    avButton
    ofType="icon"
    [size]="size"
    color="primary"
    class="room-control-min-size"
    id="btn-screen-share-start"
    (click)="toggleScreenShare()"
    [disabled]="isDisabled"
    [raised]="true"
    data-tid="display-capture/start"
  >
    <av-icon name="screen-out"></av-icon>
  </button>
</av-tooltip>
} @if (isScreenShareLocal) {
<av-tooltip message="Stop sharing">
  <button
    [attr.aria-label]="'Stop sharing screen or window' | translate"
    avButton
    ofType="icon"
    [size]="size"
    color="danger"
    class="room-control-min-size"
    id="btn-screen-share-stop"
    [disabled]="isOnHold"
    [class.pulse-danger]="!isOnHold"
    (click)="toggleScreenShare()"
    [raised]="true"
    data-tid="display-capture/stop"
  >
    <av-icon name="screen-stop"></av-icon>
  </button>
</av-tooltip>
} } @if (isTypeMenuItem) { @if (!isScreenShareLocal) {
<av-menu-item
  icon="screen-out"
  [arrow]="false"
  [disabled]="isDisabled"
  (select)="toggleScreenShare()"
>
  {{ "Share your screen" | translate }}
</av-menu-item>
} @if (isScreenShareLocal) {
<av-menu-item
  icon="screen-stop"
  [disabled]="isOnHold"
  [arrow]="false"
  color="danger"
  (select)="toggleScreenShare()"
>
  {{ "Stop sharing" | translate }}
</av-menu-item>
} }
